/* eslint-disable enforce-ids-in-jsx/missing-ids */
import React from 'react'

import { RISK_LEVELS_VALUES } from 'containers/SpearPhishingAgent/constants'

import { RiskGaugeHigh, RiskGaugeLow, RiskGaugeMedium } from 'components/lib/DesignSystem/Icons'

import { RiskMeterContainer } from '../styles'

const RISK_METER_BY_LEVEL = {
  [RISK_LEVELS_VALUES.LOW]: { Component: RiskGaugeLow },
  [RISK_LEVELS_VALUES.MEDIUM]: { Component: RiskGaugeMedium },
  [RISK_LEVELS_VALUES.HIGH]: { Component: RiskGaugeHigh },
}

const RiskMeter = ({ campaignId, level }) => {
  const RiskGaugeComponent =
    RISK_METER_BY_LEVEL[level]?.Component ||
    RISK_METER_BY_LEVEL[RISK_LEVELS_VALUES.MEDIUM].Component

  return (
    <RiskMeterContainer
      id={`Psima_Dashboard_RiskMeter_div-${campaignId}`}
      data-testid={`Psima_Dashboard_RiskMeter_div-${campaignId}`}
    >
      <RiskGaugeComponent
        id={`Psima_Dashboard_RiskMeter_icon-${campaignId}`}
        noDefaultFill
        width="27px"
        height="27px"
      />
    </RiskMeterContainer>
  )
}

export default RiskMeter
